import { render } from "./MensClothing.vue?vue&type=template&id=570c52cc"
import script from "./MensClothing.vue?vue&type=script&lang=js"
export * from "./MensClothing.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__